import { RequestMethods } from 'utils/axios/methods'
import { call, put, select } from 'redux-saga/effects'
import { Actions_PageLoader } from 'redux/modules/pageloader/Actions'
import { sagaAction_Error } from 'redux/sagas/actions/SagaAction_Error'
import { TUser } from 'redux/modules/users/TReducer'
import type { PayloadAction } from '@reduxjs/toolkit'
import { TState, TStoreTemplate } from 'redux/config/root-types'
import { Actions_CurrentUser } from 'redux/modules/currentUser/Actions'
import { Actions_Rents } from 'redux/modules/rents/Actions'
import { Actions_TrailerTypes } from 'redux/modules/trailerTypes/Actions'
import { TTrailerTypes } from 'redux/modules/trailerTypes/TReducer'
import { TStations } from 'redux/modules/stations/TReducer'
import { Actions_Stations } from 'redux/modules/stations/Actions'
import { IParking, TParkings } from 'redux/modules/parkings/TReducer'
import { Actions_Parkings } from 'redux/modules/parkings/Actions'
import { IRentFull } from 'redux/modules/rents/TReducer'

const { get } = RequestMethods()

export interface ISagaWorker_UserDetails {
  id: string
}

export default function* SagaPage_UserDetails(action: PayloadAction<ISagaWorker_UserDetails>) {
  const { id } = action.payload

  try {
    yield put(Actions_PageLoader.store.showLoader())
    //------------------------- Getting and saving user ----------------------//
    const user: TStoreTemplate<TUser> = yield call(async () => await get<TUser>(`/users/${id}`))
    yield put(Actions_CurrentUser.store.saveCurrentUser(user))

    if (user.data?.rentId) {
      const rent: TStoreTemplate<IRentFull> = yield call(
        async () => await get<IRentFull>(`/rents/${user.data?.rentId}`),
      )

      yield put(Actions_Rents.store.setUserRent(rent.data))
    }
    //------------------------- Getting and saving trailer types ---------------------------//
    const result: TStoreTemplate<TTrailerTypes> = yield call(async () => await get<TTrailerTypes>('/trailer_types'))
    yield put(Actions_TrailerTypes.store.saveTrailerTypes(result))
    //------------------------- Change rents filter ---------------------------//
    const getFilter = (state: TState) => state.rents.filter
    const rentsFilter: ReturnType<typeof getFilter> = yield select(getFilter)

    yield put(
      Actions_Rents.store.changeFilter({
        ...rentsFilter,
        sorting: 'id',
        trailerId: undefined,
        userId: id,
      }),
    )
    //------------------------- Getting and saving free stations for end the renting ----------------------//
    const stations: TStoreTemplate<TStations> = yield call(
      async () => await get<TStations>('/stations', { hideNoFreeStations: true }),
    )
    yield put(Actions_Stations.store.saveStations(stations))

    const parkingsReturnForChange: TStoreTemplate<TParkings> = yield call(
      async () => await get<TParkings>('/parking/return/forChange'),
    )
    // console.log('parkingsReturnForChange', parkingsReturnForChange)

    yield put(Actions_Parkings.store.saveParkingsReturnForChange(parkingsReturnForChange.data?.parking || []))
  } catch (e) {
    yield call(() => sagaAction_Error(e))
  } finally {
    yield put(Actions_PageLoader.store.hideLoader())
  }
}
